import { Flex } from 'pcln-design-system'
import styled from 'styled-components'

export const ItemFlex = styled(Flex)`
  height: 379px;
`
